export default function Services() {
  const services = [
    {
      title: 'Insurance Claim Assistance',
      description: 'We work directly with your insurance company to handle all paperwork and ensure you get the coverage you deserve.',
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/dc670228dd019845fecd896556e5415f.jpg',
      badge: 'Most Popular'
    },
    {
      title: 'Complete Roof Replacement',
      description: 'Premium quality materials and expert installation backed by industry-leading warranties for your peace of mind.',
      icon: 'ri-home-gear-line',
      image: 'https://readdy.ai/api/search-image?query=Expert%20roofer%20installing%20high%20quality%20architectural%20shingles%20on%20residential%20home%2C%20close-up%20of%20professional%20installation%20technique%2C%20premium%20roofing%20materials%20being%20carefully%20placed%2C%20skilled%20craftsmanship%20visible%20in%20every%20detail%2C%20bright%20sunny%20day%20with%20clear%20blue%20sky%2C%20modern%20suburban%20home%20with%20beautiful%20new%20roof%20taking%20shape%20through%20meticulous%20work&width=400&height=520&seq=service-002&orientation=portrait',
      badge: null
    },
    {
      title: 'Storm Damage Repair',
      description: 'Fast emergency response for Oklahoma weather damage. Available 24/7 to protect your home when you need us most.',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=Emergency%20roof%20repair%20team%20working%20on%20storm%20damaged%20residential%20home%2C%20professional%20crew%20securing%20tarps%20and%20making%20temporary%20repairs%2C%20Oklahoma%20weather%20aftermath%20with%20dramatic%20cloudy%20sky%2C%20urgent%20response%20showing%20dedication%20and%20reliability%2C%20safety%20equipment%20visible%20demonstrating%20professional%20standards%20and%20commitment%20to%20homeowner%20protection&width=400&height=520&seq=service-003&orientation=portrait',
      badge: '24/7 Available'
    }
  ];

  return (
    <section id="services" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#1B2838]">
            Our Roofing Services
          </h2>
          <p className="text-gray-600 text-lg hidden md:block">
            Comprehensive solutions for every roofing need
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer h-[520px]"
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B2838] via-[#1B2838]/60 to-transparent"></div>
              </div>

              {/* Badge */}
              {service.badge && (
                <div className="absolute top-6 right-6 bg-white px-4 py-2 rounded-full z-10">
                  <span className="text-[#FF6B35] text-xs font-bold">{service.badge}</span>
                </div>
              )}

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8 z-10">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-white text-4xl`}></i>
                </div>
                <h3 className="text-white text-3xl font-bold mb-3">
                  {service.title}
                </h3>
                <p className="text-white/80 text-base leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}